import React, { useState } from "react";
import siteLogo from "../../../assets/images/OrgChartNow.png";
import { toast } from "react-toastify";
import { Link, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { CompanySignIn } from "../../../services/LoginService";
import { formValidate } from "../../../helpers/formValidate";
import useForm from "../../../hooks/useForm";
import Button from "../../../components/form/Button";
import Input from "../../../components/form/Input";

const validation = {
  email: { required: true, message: "Email is required" },
  password: { required: true, message: "Password is required" },
};

const Signin = () => {
  const { values, handleChange, handleSubmit, errors, setFieldsValue } =
    useForm({}, validation);

  const navigate = useNavigate();
  const settings = useSelector((state) => state?.settings?.data);

  const [loaded, setLoaded] = useState(false);

const onSubmit = async (values) => {
  setLoaded(true);
  try {
    const res = await CompanySignIn({
      email: values?.email,
      password: values?.password,
    });

    setLoaded(false);

    if (res?.data?.status === 200) {
      localStorage.setItem("auth_token", res?.data?.accessToken);
      localStorage.setItem("refreshToken", res?.data?.refreshToken);
      localStorage.setItem("adminData", JSON.stringify({}));

      const role =
        res?.data?.data?.roleData?.find(
          (item) => item?.code === "COMPANY-ADMINISTRATOR"
        )
          ? "COMPANY-ADMINISTRATOR"
          : res?.data?.data?.roleData?.find(
              (item) => item?.code === "COMPANY-MANAGER"
            )
          ? "COMPANY-MANAGER"
          : "";

      localStorage.setItem("role", role);

      setTimeout(() => {
        navigate("/");
      }, 1000);

      toast.info(res.data.message);
    } else {
      toast.info(res.data.message || "Login failed.");
    }

  } catch (error) {
    console.error("Login error:", error);
    setLoaded(false);

    // Handle specific error cases
    if (error?.response?.data?.message) {
      toast.error(error.response.data.message);
    } else if (!navigator.onLine) {
      toast.error("No internet connection.");
    } else {
      toast.error("An unexpected error occurred. Please try again.");
    }
  }
};


  return (
    <div className="w-full min-h-screen bg-slate-50 flex items-center justify-center py-3 px-5">
      <div className="w-full max-w-md xl:max-w-md bg-white py-10 shadow-md rounded-2xl border border-orange-700 ">
        <div className="flex min-h-full flex-1 flex-col justify-center px-2 py-4 lg:px-2">
          <div className="sm:mx-auto sm:w-full sm:max-w-sm">
            <img
              className="mx-auto h-8 w-52"
              src={settings?.logo?.url || siteLogo}
              alt="Your Company"
            />
            <h2 className="mt-1 uppercase text-center text-xl font-bold leading-9 tracking-tight text-orange-700">
              User Login
            </h2>
            <h2 className="mt-1 text-center text-base font-semibold leading-9 tracking-tight text-black">
              Please Use Your Credentials to Login
            </h2>
          </div>

          <div className="mt-1 sm:mx-auto sm:w-full sm:max-w-sm">
            <form onSubmit={(event) => handleSubmit(event, onSubmit)}>
              <div className="mt-2">
                <Input
                  label={"Email"}
                  inputPlaceholder={"Enter your email"}
                  labelClasses={"!text-xs"}
                  inputType={"text"}
                  value={values.email}
                  inputName={"email"}
                  onChange={handleChange}
                  {...formValidate(errors, "email")}
                />
              </div>

              <div>
                <div className="mt-2">
                  <Input
                    label={"Password"}
                    inputPlaceholder={"Enter your password"}
                    labelClasses={"!text-xs"}
                    inputType={"password"}
                    value={values.password}
                    inputName={"password"}
                    onChange={handleChange}
                    {...formValidate(errors, "password")}
                  />
                </div>
              </div>

              <div className="mt-2">
                <Button
                  loading={loaded}
                  buttonHasLink={false}
                  buttonType={"submit"}
                  buttonLabel={"Log in"}
                  buttonIconPosition={"left"}
                  buttonIcon={"fa-light fa-right-to-bracket"}
                  buttonClasses={
                    "w-full !text-white !bg-orange-500 !hover:bg-white !hover:text-orange-500 focus-visible:outline justify-center rounded-md border border-orange-500"
                  }
                />
              </div>
              <div className="mt-4 text-end">
                <div className="text-sm">
                  <Link
                    to="/forgotPassword"
                    className="font-semibold text-victoria hover:text-orange-500"
                  >
                    Forgot password?
                  </Link>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Signin;
